module.exports = __webpack_public_path__ + "static/customheaders-cc763299a7c1264033bed7fa8cc4e1d8.png";